import { Button, CityState, DataSource, Label, Layout, Panel, StarRating, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierQuickInfo extends Layout {
    buttonCancel: Button;
    citystatePayee: CityState;
    isoCarrierLabel: Label;
    labelPendingCarrier: Label;
    panelQuickInfo: Panel;
    sourceCarriersForAssignment: DataSource;
    starratingR: StarRating;
    textboxDotNumber: Textbox;
    textboxIccNumber: Textbox;
    textboxId: Textbox;
    textboxIntrastateCode: Textbox;
    textboxPhoneNumber: Textbox;
}
